import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { TableDali } from "../TableDali";
import HeadingSection from "../../Pieces/HeadingSection";
import ModalContext from "../../../Contexts/openModal";
import CustomButton from "../../CustomButton";

const TableDaliParent = ({ slice, location }) => {
  const data = useMemo(() => slice?.props?.slice || [], [slice]);
  const { toggleModal, setTitle } = useContext(ModalContext);
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);
  const sentinelRef = useRef(null);
  const topSpacing = data?.[0]?.primary?.top_spacing;
  const bottomSpacing = data?.[data.length - 1]?.primary?.bottom_spacing;
  const emptyHeading = !!(
    data?.[0]?.primary?.caption_title?.text ||
    data?.[0]?.primary?.show_cta ||
    data?.[0]?.primary?.description?.text ||
    data?.[0]?.primary?.title?.text
  );
  
  useEffect(() => {
    const handleScroll = () => {
      if (sentinelRef.current) {
        const { bottom } = sentinelRef.current.getBoundingClientRect();
        setIsSticky(bottom <= 64);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section
        className={`relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl `}
        id="tableMonet"
      >
        <article
          className={`lg:mx-11 ${topSpacing === "80" && "sm:pt-20 pt-8"} ${topSpacing === "40" && "sm:pt-10 pt-8"} ${topSpacing === "0" && "pt-0"} ${bottomSpacing === "80" && "sm:pb-20 pb-8"} ${bottomSpacing === "40" && "sm:pb-10 pb-8"} ${bottomSpacing === "0" && "pb-0"}`}
        >
          {emptyHeading && (
            <HeadingSection
              data={data?.[0]?.primary}
              toggleModal={toggleModal}
              sectionStyle="lg:!pb-10"
              headingStyle="sm:text-3.25xl !leading-10 -tracking-[0.9px]"
              descriptionStyle="sm:text-lg custom_line_height !-tracking-[0.45px]"
              textAreaStyle="gap-4"
            />
          )}
          <div ref={sentinelRef} className="h-0" />
          <div
            ref={headerRef}
            className={`sticky lg:hidden top-16   ${
              isSticky
                ? "border-b border-b-[#E6E6E6] z-20 bg-gray-2800"
                : "bg-transparent"
            }`}
          >
            {(data?.[0]?.primary?.starter_title?.text ||
              data?.[0]?.primary?.team_title?.text ||
              data?.[0]?.primary?.enterprise_title?.text) && (
              <div className="flex justify-between pb-4 pt-7 sm:pb-6 sm:pt-10 pl-4 pr-2 md:pl-6 md:pr-10">
                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2xl sm:text-2.5xl font-manrope -tracking-[1.5px] text-gray-2500 font-semibold">
                    {data?.[0]?.primary?.starter_title?.text}
                  </p>
                  {data?.[0]?.primary?.starter_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle(data?.[0]?.primary?.starter_cta?.text);
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 sm:block hidden border border-[#BFBFBF]  rounded-full text-gray-2500 text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.starter_cta?.text}
                    />
                  )}
                </div>

                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2xl sm:text-2.5xl font-manrope -tracking-[1.5px] text-blue-1300 font-semibold">
                    {data?.[0]?.primary?.team_title?.text}
                  </p>
                  {data?.[0]?.primary?.team_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle(data?.[0]?.primary?.team_cta?.text);
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 sm:block hidden rounded-full bg-blue-1300 text-white text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.team_cta?.text}
                    />
                  )}
                </div>
                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2xl sm:text-2.5xl text-purple-1500 font-manrope -tracking-[1.5px] font-semibold">
                    {data?.[0]?.primary?.enterprise_title?.text}
                  </p>
                  {data?.[0]?.primary?.enterprise_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle("Contact Sales");
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 sm:block hidden rounded-full bg-purple-1500 text-white text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.enterprise_cta?.text}
                    />
                  )}
                </div>
              </div>
            )}
            {data?.[0]?.primary?.starter_cta?.text && (
              <CustomButton
                onClick={() => {
                  setTitle(data?.[0]?.primary?.starter_cta?.text);
                  toggleModal();
                }}
                buttonClass={`px-4 py-2 mt-4 mb-6 sm:hidden rounded-full bg-purple-1500 hover:bg-purple-2500 text-white text-base font-manrope font-semibold`}
                text={data?.[0]?.primary?.starter_cta?.text}
                isFullWidth
              />
            )}
          </div>
          {(data?.[0]?.primary?.starter_title?.text ||
            data?.[0]?.primary?.team_title?.text ||
            data?.[0]?.primary?.enterprise_title?.text) && (
            <div
              ref={headerRef}
              className={`hidden lg:flex flex-col-reverse lg:flex-row lg:items-center justify-between lg:pl-6 px-1.5 lg:pr-12 sticky top-16  ${
                isSticky
                  ? "border-b border-b-[#E6E6E6] bg-gray-2800 z-20"
                  : "bg-transparent"
              }`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
                className="text-xl sm:text-[22px] hidden lg:block pb-3 md:pb-0 tracking-tighter_1 font-inter font-medium text-gray-2700"
              />

              <div className="hidden lg:flex gap-[94px] justify-between pb-4 pt-6 sm:pb-6 sm:pt-10">
                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2.5xl font-manrope -tracking-[1.5px] text-gray-2500 font-semibold">
                    {data?.[0]?.primary?.starter_title?.text}
                  </p>
                  {data?.[0]?.primary?.starter_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle(data?.[0]?.primary?.starter_cta?.text);
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 border border-[#BFBFBF] hover:bg-gray-3004 rounded-full text-gray-2500 text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.starter_cta?.text}
                    />
                  )}
                </div>

                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2.5xl font-manrope -tracking-[1.5px] text-blue-1300 font-semibold">
                    {data?.[0]?.primary?.team_title?.text}
                  </p>
                  {data?.[0]?.primary?.team_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle(data?.[0]?.primary?.team_cta?.text);
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 rounded-full bg-blue-1300 hover:bg-blue-1700 text-white text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.team_cta?.text}
                    />
                  )}
                </div>
                <div className="flex flex-col items-center gap-3 ">
                  <p className="text-2.5xl text-purple-1500 font-manrope -tracking-[1.5px] font-semibold">
                    {data?.[0]?.primary?.enterprise_title?.text}
                  </p>
                  {data?.[0]?.primary?.enterprise_cta?.text && (
                    <CustomButton
                      onClick={() => {
                        setTitle("Contact Sales");
                        toggleModal();
                      }}
                      buttonClass={`px-4 py-2 rounded-full bg-purple-1500 hover:bg-purple-2500 text-white text-base font-manrope font-semibold`}
                      text={data?.[0]?.primary?.enterprise_cta?.text}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {/* {data?.[0]?.items[0].section_header_title?.text && (
            <div className="flex flex-col-reverse lg:flex-row items-center justify-between lg:px-6 px-1.5  border-b border-[#A8A8A8]">
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.[0]?.items[0].section_header_title.html,
                }}
                className="text-2xl sm:text-2.5xl py-3 tracking-tightest_5 sm:tracking-tightest_6 font-manrope font-semibold text-gray-2700"
              />
            </div>
          )} */}
          {data?.length > 0 &&
            data?.map((item, index) => {
              const fractionvalue = {
                Annotation: {
                  desktop: 0.543,
                  tablet: 0.546,
                  mobile: 0.58,
                },
                Index: {
                  desktop: 0.389,
                  tablet: 0.39,
                  mobile: 0.63,
                },
                Active: {
                  desktop: 0.379,
                  tablet: 0.368,
                  mobile: 0.68,
                },
              };
              return (
                <TableDali
                  visibleFraction={
                    fractionvalue[item?.items[0]?.section_header_title?.text]
                  }
                  key={index}
                  slice={item}
                  location={location}
                />
              );
            })}
        </article>
      </section>
    </>
  );
};

export default TableDaliParent;
